import { makeAutoObservable } from "mobx";
import { Controller } from "../Model/controller";
import axios from "axios";

class ControllerStore {
  collection: Controller[] = [];
  constructor() {
    makeAutoObservable(this);
    this.loadControllers();
  }

  private loadControllers() {
    axios
      .get(`https://wallof-backend.uc.r.appspot.com/controller`, {})
      .then((result) => {
        console.log(result.data);
        if (result.data && (result.data as unknown as any["controllers"])) {
          const dat_ = result.data as unknown as any;
          console.log(dat_["controllers"]);
          this.collection = dat_["controllers"];
        }
        console.log(this.collection);
      });
  }

  public add(controller: Controller) {
    axios
      .post(`https://wallof-backend.uc.r.appspot.com/controller`, controller)
      .then((result) => {
        console.log(result);
        this.loadControllers();
      })
      .catch((e) => {
        console.log(e);
      });
  }
}

export const controlleStore = new ControllerStore();
